import React, { useEffect, useState } from "react";
import { getIntegrations } from "../utilities/genesysCloudUtils";
import "../App.css";
import { Loading } from "./Loading";
import { CatalogTableSurface } from "./CatalogTableSurface";

export function Integrations({
  setPageCount,
  pageNumber,
  setPageNumber,
  setTabName,
  setIsVisible,
  selectedExportRows = {},
  exportStatus,
  onClearExportSelection,
  onExportCsv,
  onToggleExportRow,
  onToggleVisibleExportRows,
}) {
  const [integrations, setIntegrations] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPageNumber(1);
    setTabName("integrations-tab");
    setIsVisible({ divisions: false, object: false, applyButton: false });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    generateIntegrations();
  }, [pageNumber]); // eslint-disable-line react-hooks/exhaustive-deps

  const generateIntegrations = () => {
    setLoading(true);

    getIntegrations()
      .then((data) => {
        setIntegrations(data.entities);
        setPageCount(data.pageCount);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching Integrations:", error);
        setLoading(false);
      });
  };

  const allVisibleSelected = integrations.length > 0 && integrations.every((integration) => selectedExportRows[integration.id]);

  return (
    <CatalogTableSurface
      allVisibleSelected={allVisibleSelected}
      exportStatus={exportStatus}
      loading={loading}
      onClearSelection={onClearExportSelection}
      onExportCurrent={() => onExportCsv({ mode: "current", records: integrations })}
      onExportFiltered={() => onExportCsv({ mode: "all" })}
      onExportSelected={() => onExportCsv({ mode: "selected" })}
      onSelectVisible={(checked) => onToggleVisibleExportRows(integrations, checked)}
      rowCount={integrations.length}
      selectedCount={Object.keys(selectedExportRows).length}
      title="Integrations"
    >
      {loading && <Loading text="Loading Integrations..." />}
      {!loading && integrations ? (
        <>
          <table className="table">
            <thead>
              <tr>
                <th aria-label="Select rows" className="select-column"></th>
                <th className="count-column">Count</th>
                <th>Integration Name</th>
                <th>State</th>
                <th>Last Updated</th>
                <th>Integration Id</th>
              </tr>
            </thead>
            <tbody>
              {integrations.map((integration, index) => {
                return (
                  <tr key={integration.id}>
                    <td className="select-column">
                      <input
                        aria-label={`Select ${integration.name} for export`}
                        checked={Boolean(selectedExportRows[integration.id])}
                        onChange={(event) => onToggleExportRow(integration, event.target.checked)}
                        type="checkbox"
                      />
                    </td>
                    <th className="index count-column">
                      {pageNumber === 1
                        ? index + 1
                        : (pageNumber - 1) * 500 + index + 1}
                    </th>
                    <td>{integration.name}</td>
                    <td className={integration.reportedState.code === "ACTIVE" ? "integration-active" :
                      integration.reportedState.code === "INACTIVE" ? "integration-inactive" : "integration-error"
                    }>{integration.reportedState.code}</td>
                    <td>{integration.reportedState.lastUpdated}</td>
                    <td>
                      <kbd className="kbd">{integration.id}</kbd>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      ) : (
        <h1>Loading...</h1>
      )}
    </CatalogTableSurface>
  );
}
